import { render } from "./App.vue?vue&type=template&id=3dc2c2b2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3dc2c2b2&lang=scss"

import exportComponent from "/Users/yue/Documents/其他项目/数字转创/official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__